export const EProcessType = {
  "0": "UNKNOWN",
  "1": "FINANCE_VIRMAN",
  "1201": "PAYMENT_TASK_REVERSE",
  "1202": "PAYMENT_BALANCE_UPDATE",
  "1203": "PAYMENT_VCARD_UPDATE",
  "2101": "FLIGHT_ONLINE_PNR_RESERVE",
  "2102": "FLIGHT_ONLINE_PNR_SALE",
  "2103": "FLIGHT_ONLINE_PNR_SALE_RESERVED",
  "2104": "FLIGHT_ONLINE_PNR_REVERSE",
  "2105": "FLIGHT_ONLINE_ANCILLARY_SALE",
  "2106": "FLIGHT_ONLINE_ANCILLARY_REVERSE",
  "2107": "FLIGHT_ONLINE_PNR_DIVIDE",
  "2108": "FLIGHT_ONLINE_PNR_REISSUE",
  "2109": "FLIGHT_ONLINE_PNR_ACE_UPDATE",
  "2110": "FLIGHT_ONLINE_PNR_RECALCULATE",
  "2111": "FLIGHT_ONLINE_PNR_REOPTION",
  "2201": "FLIGHT_TASK_PNR_ADD",
  "2202": "FLIGHT_TASK_PNR_OPEN",
  "2203": "FLIGHT_TASK_PNR_REVERSE",
  "2204": "FLIGHT_TASK_PNR_REISSUE",
  "2205": "FLIGHT_TASK_PNR_DIVIDE",
  "2206": "FLIGHT_TASK_PNR_UPDATE",
  "2207": "FLIGHT_TASK_PNR_CORRECTION",
  "2208": "FLIGHT_TASK_PNR_UPDATE_PAX",
  "2209": "FLIGHT_TASK_ANCILLARY_SALE",
  "2210": "FLIGHT_TASK_ANCILLARY_REVERSE",
  "2301": "FLIGHT_QUEUE_SCAN",
  "2401": "FLIGHT_CRON_ORDER_CREATE",
  "3101": "HOTEL_ONLINE_VOUCHER_RESERVE",
  "3102": "HOTEL_ONLINE_VOUCHER_BOOK",
  "3103": "HOTEL_ONLINE_VOUCHER_BOOK_RESERVED",
  "3104": "HOTEL_ONLINE_VOUCHER_REVERSE",
  "3105": "HOTEL_ONLINE_VOUCHER_PARTIAL_RESERVE",
  "3106": "HOTEL_ONLINE_VOUCHER_PARTIAL_PAYMENT_1",
  "3107": "HOTEL_ONLINE_VOUCHER_PARTIAL_PAYMENT_2",
  "3201": "HOTEL_TASK_VOUCHER_ADD",
  "3202": "HOTEL_TASK_VOUCHER_REVERSE",
  "3203": "HOTEL_TASK_VOUCHER_REISSUE",
  "3204": "HOTEL_TASK_VOUCHER_ROOMDATEPRICE_UPDATE",
  "3205": "HOTEL_TASK_VOUCHER_ROOMGUEST_UPDATE",
  "3206": "HOTEL_TASK_VOUCHER_NOTE",
  "3207": "HOTEL_TASK_VOUCHER_UPDATE",
  "3208": "HOTEL_TASK_VOUCHER_RECONFIRMATION",
  "4101": "TRANSFER_ONLINE_TNR_RESERVE",
  "4102": "TRANSFER_ONLINE_TNR_TICKET",
  "4103": "TRANSFER_ONLINE_TNR_TICKET_RESERVED",
  "4104": "TRANSFER_ONLINE_TNR_REVERSE",
  "4105": "TRANSFER_ONLINE_TNR_REISSUE",
  "4201": "TRANSFER_TASK_TNR_ADD",
  "4202": "TRANSFER_TASK_TNR_REVERSE",
  "4203": "TRANSFER_TASK_TNR_REISSUE",
  "4301": "TRANSFER_SCHEDULE",
  "5101": "RENTACAR_ONLINE_RNR_RESERVE",
  "5102": "RENTACAR_ONLINE_RNR_TICKET",
  "5103": "RENTACAR_ONLINE_RNR_TICKET_RESERVED",
  "5104": "RENTACAR_ONLINE_RNR_REVERSE",
  "5105": "RENTACAR_ONLINE_RNR_REISSUE",
  "5201": "RENTACAR_TASK_RNR_ADD",
  "5202": "RENTACAR_TASK_RNR_REVERSE",
  "5203": "RENTACAR_TASK_RNR_REISSUE",
  "5204": "RENTACAR_TASK_RNR_UPDATE_DRIVER",
  "5205": "RENTACAR_TASK_ANCILLARY_SALE",
  "5206": "RENTACAR_TASK_ANCILLARY_REVERSE",
  "5207": "RENTACAR_TASK_ANCILLARY_ALL",
  "6101": "PACKAGE_ONLINE_PACKAGE_SALE",
  "6201": "PACKAGE_TASK_PACKAGE_INFO",
  "-1": "ALL"
};

export const EProcessStatus = {
  "0": "UNKNOWN",
  "1": "NEW",
  "2": "OK",
  "3": "NOK",
  "4": "EXC",
  "-1": "ALL"
};

export const EProgressType = {
  "0": "UNKNOWN",
  "1": "HOTEL_CONTENT_IMPORT",
  "2": "HOTEL_IMPORT",
  "3": "ACCOUNTING_DEPOSIT_SYNC",
  "4": "ACCOUNTING_INVOICE_SYNC",
  "5": "ACCOUNTING_COLLECTION_SYNC",
  "6": "VIRTUALCARD_UPDATE",
  "7": "ASYNC_EXCEL_EXPORT",
  "8": "HOTEL_BENCHMARK",
  "9": "REORGANIZE_INDEX_HTL_INT_ROOM_PRICE",
  "10": "REPORT_PROCESS_TYPES",
  "11": "REPORT_IFRS_SEND_EMAIL",
  "12": "REPORT_IFRS_REFRESH_DATA",
  "13": "TRANSFER_LOCATION_IMPORT",
  "-1": "ALL"
};

export const EProgressStatus = {
  "0": "UNKNOWN",
  "1": "IN_PROGRESS",
  "2": "COMPLETED",
  "-1": "ALL"
};